import { Reducer } from 'redux';
import { DEFAULT_PER_PAGE_COUNT } from '@/services/constants';

import { SegmentsState } from './types';

const defaultState: SegmentsState = {
    isLoadingSegments: false,
    isLoadingSegmentsNames: false,
    collection: null,
    visibleSet: null,
    selected: null,
    historyTrackedCollection: null,
    ruleEvaluationResult: null,
    currentCollectionTotalCount: null,
    pagination: {
        activePage: 1,
        perPage: DEFAULT_PER_PAGE_COUNT,
        searchName: null,
    },
};

const reducer: Reducer<SegmentsState> = (state = defaultState, action): SegmentsState => {
    const { type } = action;
    switch (type) {
        case '@@segments/FETCH_START':
        case '@@segments/SINGLE_FETCH_START':
            return { ...state, isLoadingSegments: true };
        case '@@segments/FETCH_SEGMENTNAMES_START':
            return { ...state, isLoadingSegmentsNames: true };
        case '@@segments/FETCH_SEGMENTNAMES_ERROR':
            return { ...state, isLoadingSegmentsNames: false };
        case '@@segments/FETCH_SEGMENTNAMES_SUCCESS':
            return { ...state, ...action.payload, isLoadingSegmentsNames: false };
        case '@@segments/FETCH_ERROR':
        case '@@segments/FETCH_SUCCESS':
        case '@@segments/SINGLE_FETCH_SUCCESS':
        case '@@segments/SELECT':
        case '@@segments/DESELECT':
        case '@@segments/ADD_START':
        case '@@segments/SET_COLLECTION':
            return { ...state, ...action.payload };
        case '@@segments/LOAD_HISTORY_TRACKED_ERROR':
            return { ...state, ...action.payload.isLoadingSegments };
        case '@@segments/LOAD_HISTORY_TRACKED_SUCCESS':
        case '@@segments/LOAD_BY_CONTACT_SUCCESS':
        case '@@segments/UPDATE_RULE_EVALUATION_RESULT':
        case '@@segments/CLEAR_RULE_EVALUATION_RESULT':
        case '@@segments/UPDATE_EDITED_SUCCESS':
            return { ...state, ...action.payload };
        case '@@segments/LOAD_HISTORY_TRACKED_START':
            return { ...state, isLoadingSegments: true };
        case '@segments/SET_PAGINATION':
            return { ...state, pagination: { ...action.payload } };
        default:
            return state;
    }
};

export { reducer as segments };

export default reducer;
